import Vue from 'vue';
import _ from 'lodash';

export const showErrorToast = _.debounce(Vue.$toast.error, 500);
